import {CircleCheck} from "lucide-react";
import {Fragment, useEffect, useState} from "react";
import PaymentInformationAPI from '~/api/paymentInformationApi';
import {useNavigate, useParams} from "react-router-dom";
import {format} from "date-fns";
function PaymentSuccess() {
    const navigate = useNavigate();
    const [paymentInfo, setPaymentInfo] = useState(null);
    const [countDown, setCountDown] = useState(7);
    const { id } = useParams();
    useEffect(function () {
        PaymentInformationAPI.paymentSuccess(id)
            .then(res => {
                if(res.data?.Succeeded == false){
                    navigate("/auth/error/404", { replace: true });
                    return;
                }
                else {
                    setPaymentInfo(res.data);
                }
            })
    }, []);

    useEffect(() => {
        if (countDown <= 0){
            navigate("/ai-chatbot/chat", { replace: true });
            return;
        }

        const timer = setInterval(() => {
            setCountDown(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countDown]);

    return (
        <Fragment>
        {
            paymentInfo && (
                <div className="text-center pt-10">
                    <CircleCheck size={30} className="text-success"/>
                    <h4 className="mt-2 fw-semibold">Payment Successful</h4>

                    <p className="fs-8-1 mt-7">
                        🎉 Congratulations! Your payment was successful and your service is now active.
                    </p>

                    <div className="d-flex justify-content-center">
                        <div className="w-50">
                            <ul className="list-group list-group-flush text-start mb-4 ">
                                <li className="list-group-item d-flex justify-content-between">
                                    <span className="text-muted">Amount</span>
                                    <strong>${paymentInfo.Amount}</strong>
                                </li>
                                <li className="list-group-item d-flex justify-content-between">
                                    <span className="text-muted">Transaction ID</span>
                                    <strong>{paymentInfo.PaymentIntentId}</strong>
                                </li>
                                <li className="list-group-item d-flex justify-content-between">
                                    <span className="text-muted">Date</span>
                                    <strong>{format(new Date(paymentInfo.CreatedAt), "dd-MM-yyyy hh:mm:ss a")}</strong>
                                </li>
                                <li className="list-group-item d-flex justify-content-between">
                                    <span className="text-muted">Payment Method</span>
                                    <strong>{paymentInfo.CardBrand} •••• {paymentInfo.CardLast4}</strong>
                                </li>
                            </ul>

                            <div className="text-success fw-medium mb-4">
                                Service Activated
                            </div>

                            <p className="text-muted fs-9 mt-3">
                                You will be redirected to the chatbot page in <strong>7 seconds</strong>.
                                If you are not redirected automatically,
                                <a href="/ai-chatbot/chat" className="text-decoration-none fw-semibold px-1">
                                    click here
                                </a>
                                to continue.
                            </p>
                        </div>
                    </div>
                </div>
            )
        }
        </Fragment>
    )
}

export default PaymentSuccess;